import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// 디자인 토큰 (--t-*). 기존 --white/--black 과 접두사가 달라 병존합니다.
// 아직 신규 컴포넌트(components/ds)에서만 사용하므로 기존 화면에 영향 없음.
import "./styles/tokens.css";
import Router from "./routers";
import reportWebVitals from "./reportWebVitals";
import initI18n from "locales/i18n";
import { Device } from "common/device";
// 개발 전용 목 모드 — ?mock=1 일 때만. prod 에서는 내부에서 무조건 비활성.
import { setupMockAuth } from "./dev/mockMode";
import { setupMockApi } from "./dev/mockApi";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

// 다크모드 비활성화 (추후 사용자 설정으로 전환)
document.documentElement.classList.remove("dark");
setupMockAuth();
setupMockApi();
initI18n();

// 모바일 키보드 대응 — 하단 고정 버튼 바(ds ButtonFooter)를 보이는 영역 바닥에 붙입니다.
//
// position:fixed 는 '레이아웃 뷰포트' 기준입니다. 키보드가 올라와도 레이아웃 뷰포트는
// 그대로인 기기(안드로이드 RN WebView 등)에서는 레이아웃 바닥이 키보드 뒤에 숨습니다.
// 그래서 그 차이만큼 bottom 을 올려 줘야 하는데, 두 가지가 빠져 있었습니다.
//
//   · offsetTop — OS 가 화면을 밀어 올리면(pan) 보이는 뷰포트가 위로 이동합니다.
//     이걸 빼먹으면 밀어 올린 만큼 계산이 어긋납니다.
//   · scroll 이벤트 — 보이는 뷰포트는 스크롤할 때도 움직입니다. resize 만 들으면
//     키보드가 떠 있는 동안 스크롤할 때 버튼 바가 갱신되지 않아 스크롤을 따라다닙니다.
//
// innerHeight - (height + offsetTop) = 레이아웃 바닥과 보이는 영역 바닥 사이의 간격.
// 키보드가 없으면 0 이고, OS 가 창을 줄이는 adjustResize 에서도 0 이라 그대로 맞습니다.
if (window.visualViewport) {
	const vv = window.visualViewport;
	// 스크롤 갱신까지 0.15s 로 굴리면 버튼 바가 스크롤을 뒤늦게 따라오는 잔상이 됩니다.
	// 키보드가 오르내릴 때(resize)만 부드럽게, 스크롤 보정(scroll)은 즉시.
	const syncKeyboardOffset = (instant: boolean) => {
		const gap = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
		const root = document.documentElement;
		root.style.setProperty('--keyboard-ease', instant ? '0s' : '0.15s');
		root.style.setProperty('--keyboard-offset', `${gap}px`);
	};
	vv.addEventListener('resize', () => syncKeyboardOffset(false));
	vv.addEventListener('scroll', () => syncKeyboardOffset(true));
	syncKeyboardOffset(true);
}

root.render(
  // <React.StrictMode>
  <Router />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
